<template>
    <v-content>
        <slot />
    </v-content>
</template>

<script>
    export default {
        name: "Guest"
    }
</script>

<style scoped>

</style>
